export default __webpack_public_path__ + "assets/2e875f398df3a9a99053de3ed045cf0c.png";